<template lang="pug">
validation-observer(ref='observer' tag='form')
  div
    el-row
      div#pdf(v-if="bytes")
        app-pdf-viewer(:bytes="bytes")

    el-row
      div.container
        app-radios-tramitacao(
          v-if="radiosAcoes.length",
          :radios="radiosAcoes",
          :isDecisao="true",
          :radioInicial="radioInicial",
          @changeRadio="changeRadio"
        )

    el-row
      div#btn
        app-buttons-cadastro(
          :showButtonDownload="true",
          :showButtonCancelar="false",
          :isUltimoPasso="true"
          finalizarLabel="Finalizar",
          downloadLabel="Download PDF",
          @download="download",
          @voltar="goToListagem",
          @finalizar="finalizar"
        )
</template>

<script>
import { mapActions } from 'vuex'
import AppPDFViewer from '@/components/AppPDFViewer'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppOnlyInputNumbers from '@/components/mixins/AppOnlyInputNumbers'
import AppLabel from '@/components/AppLabel'
import FileHelper from '@/utils/fileHelper'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import Divider from '@/screens/arrecadacao/components/Divider'
import BaseAnaliseProcessos from '@/screens/arrecadacao/mixins/BaseAnaliseProcessos'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'

export default {
  components: {
    AppPdfViewer: AppPDFViewer,
    AppButtonsCadastro,
    AppLabel,
    Divider,
    AppRadiosTramitacao
  },

  mixins: [AppOnlyInputNumbers, AppNotificacao, BaseAnaliseProcessos],

  props: {
    processo: { required: true, type: Object },
    radiosAcoes: { required: true, type: Array },
    routeListagemName: { required: true, type: String }
  },

  data () {
    return {
      bytes: null
    }
  },

  methods: {
    ...mapActions({
      getPDFPortaria: 'portariaArrecadacao/getPDFPortariaAssinado',
      tramitarComAcao: 'processoArrecadacao/tramitarComAcao'
    }),

    async renderPDF (idPortaria) {
      this.bytes = null
      this.bytes = await this.getPDFPortaria(idPortaria)
    },

    download () {
      FileHelper.saveFile(this.bytes, 'portaria.pdf')
    },

    async finalizar () {
      const valido = await this.$refs.observer.validate()

      if (valido) {
        this.confirmBox(
          'Deseja confirmar esta ação?',
          this.$messages.TITULO_WARNING,
          async () => {
            try {
              await this.tramitarComAcao(this.despacho)

              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.SUCESSO_ENCAMINHAR_PUBLICACAO
              )

              this.goToListagem()
            } catch (e) {
              this.showNotificacao(
                this.$messages.TIPO_WARNING,
                this.$messages.TITULO_WARNING,
                this.$messages.ERRO_VALIDACAO_ENUMERAR_PORTARIA
              )
            }
          },
          () => {},
          'Sim',
          'Não'
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_ENUMERAR_PORTARIA
        )
      }
    }
  },

  mounted () {
    const { idPortaria, idProcesso } = this.$route.query
    this.renderPDF(idPortaria)
    this.despacho.processoId = idProcesso
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.container-input {
  margin-right: 20px;
}

.button {
  margin-top: 5px;
}

.container-pdf {
  padding-top: 20px;
  width: 100%;
}

#pdf >>> .card-info {
  margin: 0%;
}

#btn >>> .buttons {
  padding-left: 0px;
  padding-right: 0px;
}

.text-container {
  padding-bottom: 50px;
}

.text-container >>> .label-divider {
  padding-top: 0px;
}

>>> .el-radio__label {
  font-size: 16px;
}
>>> .el-radio.erro-teste {
  border: 2px firebrick solid;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/diarioOficial/EncaminharPublicacao.vue